// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"c2e967c8","802":"3cc70d76"}[chunkId] + ".chunk.css";
};